<div class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >place</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.learningCategory' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <mat-table class="shared-links-table"
        #table [dataSource]="platforms"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header style="width: 30%">{{'platform.title' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let pl" style="width: 30%">
            <p class="text-truncate" [ngClass]="{'margin': pl.type && pl.type === 'space'}">{{pl.title}}</p>
          </mat-cell>
        </ng-container>
        <!-- Image Column -->
        <ng-container cdkColumnDef="link">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header style="width: 70%">{{'module.url' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lc" style="width: 70%">
            <div class="link" (click)="copyCodeFunc(lc.id)">
              <input id="copyEmbedUrl_{{lc.id}}"  style="width: 100%"
                value='<embed type="text/html" src="{{lc.embedUrl}}" width="100%" height="100%">' readonly>
              </div>
            </mat-cell>
          </ng-container>


          <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

          <mat-row *cdkRowDef="let lc; columns: displayedColumns;"
            class="product"
            matRipple>
          </mat-row>

        </mat-table>
        @if (platforms.length === 0) {
          <div class="no-data-msg">
            <span class="mat-headline-6">{{'main.noData' | translate}}</span>
          </div>
        }

      </div>
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </div>
